module.exports = __webpack_public_path__ + "static/phone@3x-072163609de6904b03257d2b074f6a81.png";